module.exports = __webpack_public_path__ + "img/Adobe_Certified_Professional_Certificate.d91a583f.png";